import createRemoteArrayResourceReducer from "./helpers/createRemoteArrayResourceReducer";

export default createRemoteArrayResourceReducer("MICROCODES");
